export const CONSTANTS = {
    APIURL: "https://server.skysep.in"
}